import { apiUrl } from '../runtime'

export interface UserBasic {
  id: number
  username: string
  discord_username: string
  avatar_url: string
}

// Browser replacement for fetchUsers (the restricted-user picker in CreateMarketButton).
export async function fetchUsers(): Promise<UserBasic[]> {
  try {
    const res = await fetch(apiUrl('/api/users'), { credentials: 'include', cache: 'no-store' })
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}
